import React from "react";
import { Button, TopToolbar } from "react-admin";
import { useNavigate } from "react-router";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { RECORDS, STUDENT_EDUCATION, StudentServicePath, InternshipStudentStatuses } from "utils/constants";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { studentRequests } from "api/studentApi";
import StartInternshipDialog from "./StartInternshipDialog";
import SchoolIcon from "@mui/icons-material/School";
import GenerateDocumentButton from "components/Erasmus/Partials/GenerateDocumentButton";

const StudentRecordToolbar = ({
  educationId,
  internshipStudentStatus,
  record,
  fetchHistory,
  fetchInternshipStudentStatus,
}) => {
  const navigate = useNavigate();
  return (
    <TopToolbar sx={{ paddingTop: "2rem" }}>
      <SecuredComponent permission={permissions.canGenerateAcademicRequestDocuments}>
        <GenerateDocumentButton
          url={studentRequests.getStudentAcademicReport(educationId)}
          fileName="academic-report"
          label="Академична справка"
          margin={0}
        />
      </SecuredComponent>
      {internshipStudentStatus === InternshipStudentStatuses.None && (
        <SecuredComponent permission={permissions.canStartInternshipForStudents}>
          <StartInternshipDialog
            userId={record?.userInfo?.userId}
            specialityId={record?.specialityId}
            studyGroup={record?.studyGroup}
            educationId={educationId}
            fetchInternshipStudentStatus={fetchInternshipStudentStatus}
            fetchHistory={fetchHistory}
          />
        </SecuredComponent>
      )}

      {internshipStudentStatus !== InternshipStudentStatuses.None && internshipStudentStatus && (
        <SecuredComponent permission={permissions.canPreviewInternshipStudents}>
          <Button
            label="Преддипломен стаж"
            size="medium"
            variant="outlined"
            startIcon={<SchoolIcon />}
            onClick={() => navigate(`/graduation/students/${educationId}/show`)}
          />
        </SecuredComponent>
      )}
      <SecuredComponent permission={permissions.canPreviewStudentRecords}>
        <Button
          label="Студентски картон"
          variant="contained"
          size="medium"
          color="warning"
          startIcon={<ReceiptLongIcon />}
          onClick={() => navigate(`/${StudentServicePath}${RECORDS}/${STUDENT_EDUCATION}/${educationId}`)}
        />
      </SecuredComponent>
      <Button
        label="Назад"
        variant="contained"
        size="medium"
        color="error"
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(-1)}
      />
    </TopToolbar>
  );
};

export default StudentRecordToolbar;
